<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="calendar.id ? '编辑' : '新建'"
      width="1200px"
      top="5vh"
      @close="resetForm"
  >
    <el-form
        ref="form"
        :model="calendar"
        :rules="ruleValidate"
        label-width="140px"
        label-suffix=" :">
      <div class="fm-section-title">基本信息</div>
      <el-row :gutter="10">
        <el-col v-if="calendar.id" :span="12">
          <el-form-item label="日历编码">
            <el-input v-model="calendar.calendarCode" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日历名称" prop="calendarName">
            <el-input v-model="calendar.calendarName"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="日历类型" prop="calendarType">
            <el-select v-model="calendar.calendarType" clearable>
              <el-option v-for="item in calendarTypeOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="状态" prop="calendarStatus">
            <el-select v-model="calendar.calendarStatus" clearable>
              <el-option v-for="item in calendarStatusOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">归属信息</div>
      <el-row :gutter="10">
        <el-col v-if="calendar.calendarType === 1" :span="12">
          <el-form-item label="工厂编码">
            <el-input v-model="calendar.plantCode"/>
          </el-form-item>
        </el-col>
        <el-col v-if="calendar.calendarType === 2" :span="12">
          <el-form-item label="车间编码">
            <el-input v-model="calendar.workshopCode"/>
          </el-form-item>
        </el-col>
        <el-col v-if="calendar.calendarType === 3" :span="12">
          <el-form-item label="产线编码">
            <el-input v-model="calendar.lineCode"/>
          </el-form-item>
        </el-col>
        <el-col v-if="calendar.calendarType === 4" :span="12">
          <el-form-item label="设备工装ID">
            <el-input-number v-model="calendar.resourceId" :min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col v-if="calendar.calendarType === 5" :span="12">
          <el-form-item label="班组ID">
            <el-input-number v-model="calendar.teamId" :min="0" controls-position="right"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="父级日历">
            <el-input v-model="parentCalendarName" placeholder="请选择父级日历" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.parentCalendarSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">有效期</div>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="生效日期">
            <el-date-picker v-model="calendar.startDate" type="date" value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="失效日期">
            <el-date-picker v-model="calendar.endDate" type="date" value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="fm-section-title">备注</div>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input v-model="calendar.remark" type="textarea" :rows="2"/>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <!-- 特殊日期列表 -->
    <div class="fm-section-title">特殊日期</div>
    <div style="margin-bottom: 15px">
      <el-button type="success" size="small" icon="el-icon-plus" @click="openSpecialDateDialog()">新增特殊日期</el-button>
      <el-table :data="specialDateList.filter(d => !d._deleted)" border size="small" style="margin-top: 10px">
        <el-table-column prop="specialDate" label="特殊日期" align="center"/>
        <el-table-column prop="dateType" label="日期类型" align="center">
          <template slot-scope="{ row }">
            {{dateTypeMap[row.dateType] || row.dateType}}
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="原因" min-width="150"/>
        <el-table-column prop="effectHour" label="有效工时(小时)" align="right"/>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openSpecialDateDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="del" @click="handleDeleteSpecialDate(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 班次列表 -->
    <div class="fm-section-title">班次列表</div>
    <div style="margin-bottom: 15px">
      <el-button type="success" size="small" icon="el-icon-plus" @click="openNewShiftDialog">新增班次</el-button>
      <el-table :data="shiftList.filter(s => !s._deleted)" border size="small" style="margin-top: 10px">
        <el-table-column prop="shiftCode" label="班次编码" align="center"/>
        <el-table-column prop="shiftName" label="班次名称"/>
        <el-table-column prop="shiftType" label="班次类型" align="center">
          <template slot-scope="{ row }">
            {{shiftTypeMap[row.shiftType] || row.shiftType}}
          </template>
        </el-table-column>
        <el-table-column prop="weekdayRule" label="周生效规则" align="center">
          <template slot-scope="{ row }">
            {{weekdayMap[row.weekdayRule] || row.weekdayRule}}
          </template>
        </el-table-column>
        <el-table-column prop="sortNum" label="排序" align="right"/>
        <el-table-column prop="startDate" label="生效日" align="center"/>
        <el-table-column prop="endDate" label="失效日" align="center"/>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openShiftEditDialog(row)">编辑</el-button>
            <el-button type="text" size="small" class="del" @click="handleDeleteShift(row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 父级日历选择 -->
    <calendar-select
        ref="parentCalendarSelect"
        title="选择父级日历"
        :filter="calendarFilter"
        @select="selectParentCalendar"
    />

    <!-- 班次模板选择 -->
    <calendar-shift-select
        ref="shiftSelect"
        title="选择班次模板"
        :filter="shiftFilter"
        @select="selectShiftForBind"
    />

    <!-- 特殊日期弹窗 -->
    <el-dialog
        v-el-drag-dialog
        :visible.sync="specialDateDialogVisible"
        :close-on-click-modal="false"
        :title="specialDateEditId ? '编辑特殊日期' : '新增特殊日期'"
        width="500px"
        append-to-body
    >
      <el-form ref="specialDateForm" :model="specialDateFormData" label-width="110px" label-suffix=" :">
        <el-form-item label="特殊日期" prop="specialDate">
          <el-date-picker v-model="specialDateFormData.specialDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="日期类型" prop="dateType">
          <el-select v-model="specialDateFormData.dateType" style="width: 100%">
            <el-option v-for="item in dateTypeOptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="开始时间">
          <el-time-picker v-model="specialDateFormData.stopStart" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="结束时间">
          <el-time-picker v-model="specialDateFormData.stopEnd" format="HH:mm:ss" value-format="HH:mm:ss" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="有效工时(小时)">
          <el-input-number
              v-model="specialDateFormData.effectHour"
              :min="0"
              :precision="1"
              controls-position="right"
              style="width: 100%"/>
        </el-form-item>
        <el-form-item label="原因">
          <el-input v-model="specialDateFormData.reason"/>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="specialDateFormData.remark" type="textarea" :rows="2"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="specialDateDialogVisible = false">取消</el-button>
        <el-button :loading="specialDateLoading" type="primary" @click="handleSaveSpecialDate">确定</el-button>
      </span>
    </el-dialog>

    <!-- 班次绑定弹窗 -->
    <el-dialog
        v-el-drag-dialog
        :visible.sync="shiftBindDialogVisible"
        :close-on-click-modal="false"
        :title="shiftBindEditId ? '编辑班次绑定' : '添加班次绑定'"
        width="450px"
        append-to-body
    >
      <el-form ref="shiftBindForm" :model="shiftBindFormData" label-width="100px" label-suffix=" :">
        <el-form-item v-if="!shiftBindEditId" label="选择班次">
          <el-input v-model="shiftBindFormData.shiftName" placeholder="请选择班次模板" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.shiftSelect.open()"/>
          </el-input>
        </el-form-item>
        <el-form-item v-else label="班次名称">
          <el-input v-model="shiftBindFormData.shiftName" disabled/>
        </el-form-item>
        <el-form-item label="班次编码">
          <el-input v-model="shiftBindFormData.shiftCode" disabled/>
        </el-form-item>
        <el-form-item label="类别">
          <el-input :value="shiftTypeMap[shiftBindFormData.shiftType] || shiftBindFormData.shiftType" disabled/>
        </el-form-item>
        <el-form-item label="周生效规则">
          <el-select v-model="shiftBindFormData.weekdayRules" multiple collapse-tags style="width: 100%" placeholder="请选择周生效规则">
            <el-option v-for="item in weekdayOptions" :key="item.value" :label="item.label" :value="item.value"/>
          </el-select>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="shiftBindFormData.sortNum" :min="0" controls-position="right" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="生效日">
          <el-date-picker v-model="shiftBindFormData.startDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"/>
        </el-form-item>
        <el-form-item label="失效日">
          <el-date-picker v-model="shiftBindFormData.endDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="shiftBindDialogVisible = false">取消</el-button>
        <el-button :loading="shiftBindLoading" type="primary" @click="handleSaveShiftBind">确定</el-button>
      </span>
    </el-dialog>

    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="submitHandle">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CalendarSelect from "./CalendarSelect";
  import CalendarShiftSelect from "../calendar-shift/CalendarShiftSelect";

  export default {
    components: { CalendarSelect, CalendarShiftSelect },
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        parentCalendarName: "",
        calendarTypeOptions: [
          { label: "工厂日历", value: 1 },
          { label: "车间日历", value: 2 },
          { label: "产线日历", value: 3 },
          { label: "设备资源日历", value: 4 },
          { label: "班组日历", value: 5 },
        ],
        calendarStatusOptions: [
          { label: "禁用", value: 0 },
          { label: "启用", value: 1 },
        ],
        // 父级日历选择
        calendarFilter: { calendarCode: "", calendarName: "" },
        // 班次模板选择
        shiftFilter: { shiftCode: "", shiftName: "" },
        dateTypeOptions: [
          { label: "法定节假日", value: 1 },
          { label: "计划检修停工", value: 2 },
          { label: "临时停产", value: 3 },
          { label: "调休工作日", value: 4 },
          { label: "半天停工", value: 5 },
          { label: "节假日加班", value: 6 },
        ],
        dateTypeMap: {
          1: "法定节假日",
          2: "计划检修停工",
          3: "临时停产",
          4: "调休工作日",
          5: "半天停工",
          6: "节假日加班",
        },
        shiftTypeMap: {
          1: "白班",
          2: "中班",
          3: "晚班",
          4: "混合多班",
        },
        weekdayMap: {
          0: "全周",
          1: "周一",
          2: "周二",
          3: "周三",
          4: "周四",
          5: "周五",
          6: "周六",
          7: "周日",
        },
        weekdayOptions: [
          { label: "全周", value: 0 },
          { label: "周一", value: 1 },
          { label: "周二", value: 2 },
          { label: "周三", value: 3 },
          { label: "周四", value: 4 },
          { label: "周五", value: 5 },
          { label: "周六", value: 6 },
          { label: "周日", value: 7 },
        ],
        calendar: {},
        ruleValidate: {
          calendarName: { required: true, message: "请输入日历名称", trigger: "blur" },
          calendarType: { required: true, message: "请选择日历类型", trigger: "change" },
          calendarStatus: { required: true, message: "请选择状态", trigger: "change" },
        },
        // 特殊日期
        specialDateList: [],
        specialDateDialogVisible: false,
        specialDateEditId: undefined,
        specialDateLoading: false,
        specialDateFormData: {
          specialDate: "",
          dateType: 1,
          stopStart: "",
          stopEnd: "",
          effectHour: 0,
          reason: "",
          remark: "",
        },
        // 班次绑定
        shiftList: [],
        shiftBindDialogVisible: false,
        shiftBindLoading: false,
        shiftBindEditId: undefined,
        shiftBindShiftId: undefined,
        shiftBindFormData: {
          shiftName: "",
          shiftCode: "",
          shiftType: undefined,
          weekdayRules: [],
          sortNum: 0,
          startDate: "",
          endDate: "",
        },
      };
    },
    methods: {
      resetForm() {
        this.$refs.form && this.$refs.form.resetFields();
      },
      async open(row) {
        this.dialogVisible = true;
        this.parentCalendarName = "";
        this.specialDateList = [];
        this.shiftList = [];
        this.calendar = Object.assign(
          {
            id: undefined,
            calendarName: "",
            calendarCode: "",
            calendarType: 1,
            plantCode: "",
            workshopCode: "",
            lineCode: "",
            resourceId: undefined,
            teamId: undefined,
            parentCalendarId: undefined,
            startDate: "",
            endDate: "",
            calendarStatus: 1,
            remark: "",
          },
          row || {}
        );

        // 编辑模式：加载完整详情（含班次、特殊日期、父级日历名称）
        if (this.calendar.id) {
          this.$http
            .get("basic", `fm/calendarMain/${this.calendar.id}`)
            .then((resp) => {
              if (resp.success && resp.data) {
                const detail = resp.data;
                this.calendar = Object.assign(this.calendar, detail);
                this.parentCalendarName = detail.parentCalendarName || "";
                this.specialDateList = (detail.specialDates || []).map((d) => ({ ...d }));
                this.shiftList = (detail.shifts || []).map((s) => ({ ...s }));
              }
            })
            .catch(() => {});
        }
      },
      // 父级日历选择
      selectParentCalendar(row) {
        this.calendar.parentCalendarId = row.id;
        this.parentCalendarName = row.calendarName;
      },
      // ==================== 特殊日期管理 ====================
      openSpecialDateDialog(row) {
        if (row) {
          this.specialDateEditId = row.id;
          this.specialDateFormData = {
            specialDate: row.specialDate || "",
            dateType: row.dateType || 1,
            stopStart: row.stopStart || "",
            stopEnd: row.stopEnd || "",
            effectHour: row.effectHour || 0,
            reason: row.reason || "",
            remark: row.remark || "",
          };
        } else {
          this.specialDateEditId = undefined;
          this.specialDateFormData = {
            specialDate: "",
            dateType: 1,
            stopStart: "",
            stopEnd: "",
            effectHour: 0,
            reason: "",
            remark: "",
          };
        }
        this.specialDateDialogVisible = true;
      },
      handleSaveSpecialDate() {
        const item = { ...this.specialDateFormData, calendarId: this.calendar.id };
        if (this.specialDateEditId) {
          const idx = this.specialDateList.findIndex((d) => d.id === this.specialDateEditId);
          if (idx !== -1) {
            this.specialDateList[idx] = { ...this.specialDateList[idx], ...item };
            this.specialDateList[idx]._changed = true;
          }
        } else {
          item.id = -Date.now();
          item._new = true;
          this.specialDateList.push(item);
        }
        this.specialDateDialogVisible = false;
      },
      handleDeleteSpecialDate(id) {
        this.$confirm("确认删除该特殊日期？", "提示", { type: "warning" })
          .then(() => {
            const idx = this.specialDateList.findIndex((d) => d.id === id);
            if (idx !== -1) {
              if (this.specialDateList[idx]._new) {
                this.specialDateList.splice(idx, 1);
              } else {
                this.specialDateList[idx]._deleted = true;
              }
            }
          })
          .catch(() => {});
      },
      // ==================== 班次管理 ====================
      openNewShiftDialog() {
        this.shiftBindEditId = undefined;
        this.shiftBindShiftId = undefined;
        this.shiftBindFormData = {
          shiftName: "",
          shiftCode: "",
          shiftType: undefined,
          weekdayRules: [],
          sortNum: 0,
          startDate: "",
          endDate: "",
        };
        this.shiftBindDialogVisible = true;
      },
      openShiftEditDialog(row) {
        this.shiftBindEditId = row.id;
        this.shiftBindShiftId = row.shiftId || row.id;
        // 编辑时是单条记录，将单个周规则值转为数组回显
        const weekdayRule = Number(row.weekdayRule);
        this.shiftBindFormData = {
          shiftName: row.shiftName || "",
          shiftCode: row.shiftCode || "",
          shiftType: row.shiftType != null ? row.shiftType : undefined,
          weekdayRules: Number.isFinite(weekdayRule) ? [weekdayRule] : [],
          sortNum: Number(row.sortNum) || 0,
          startDate: this.formatDateStr(row.startDate),
          endDate: this.formatDateStr(row.endDate),
        };
        this.shiftBindDialogVisible = true;
      },
      selectShiftForBind(row) {
        this.shiftBindShiftId = row.id;
        this.shiftBindFormData.shiftName = row.shiftName || "";
        this.shiftBindFormData.shiftCode = row.shiftCode || "";
        this.shiftBindFormData.shiftType = row.shiftType != null ? row.shiftType : undefined;
      },
      formatDateStr(val) {
        if (!val) return "";
        const str = String(val);
        return str.length >= 10 ? str.substring(0, 10) : str;
      },
      handleSaveShiftBind() {
        const weekdayRules = this.shiftBindFormData.weekdayRules || [];
        if (weekdayRules.length === 0) {
          this.$message.warning("请至少选择一个周生效规则");
          return;
        }
        if (this.shiftBindEditId) {
          // 编辑已有单条记录：直接更新该条记录的周规则
          const idx = this.shiftList.findIndex((s) => s.id === this.shiftBindEditId);
          if (idx !== -1) {
            const { weekdayRules: _rules, ...rest } = this.shiftBindFormData;
            Object.assign(this.shiftList[idx], rest, { weekdayRule: weekdayRules[0] });
            this.shiftList[idx]._changed = true;
          }
        } else {
          // 新增：按勾选的周日期批量生成独立记录，每条对应一个 weekdayRule
          const { weekdayRules: _rules, ...rest } = this.shiftBindFormData;
          weekdayRules.forEach((rule) => {
            const item = {
              ...rest,
              weekdayRule: rule,
              id: -Date.now() - rule,
              shiftId: this.shiftBindShiftId,
              _new: true,
            };
            this.shiftList.push(item);
          });
        }
        this.shiftBindDialogVisible = false;
      },
      handleDeleteShift(id) {
        this.$confirm("确认解绑该班次？", "提示", { type: "warning" })
          .then(() => {
            const idx = this.shiftList.findIndex((s) => s.id === id);
            if (idx !== -1) {
              if (this.shiftList[idx]._new) {
                this.shiftList.splice(idx, 1);
              } else {
                this.shiftList[idx]._deleted = true;
              }
            }
          })
          .catch(() => {});
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            // 组装子表数据
            const payload = {
              ...this.calendar,
              specialDates: this.specialDateList
                .filter((d) => !d._deleted)
                .map((d) => {
                  const item = { ...d };
                  delete item._new;
                  delete item._changed;
                  delete item._deleted;
                  return item;
                }),
              shifts: this.shiftList
                .filter((s) => !s._deleted)
                .map((s) => {
                  const item = { ...s };
                  delete item._new;
                  delete item._changed;
                  delete item._deleted;
                  return item;
                }),
            };
            let request;
            if (this.calendar.id) {
              // 编辑：PUT /fm/calendarMain/{calendarId}
              request = this.$http.put("basic", `fm/calendarMain/${this.calendar.id}`, payload);
            } else {
              // 新增：POST /fm/calendarMain
              request = this.$http.post("basic", "fm/calendarMain", payload);
            }
            request
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success(this.calendar.id ? "编辑成功" : "添加成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style scoped>
.fm-section-title {
  font-weight: bold;
  padding: 10px 0 5px;
  margin-bottom: 10px;
  border-bottom: 1px solid #e8e8e8;
  color: #409eff;
}
.del {
  color: #f56c6c;
}
</style>
